// Default options for the plugin.
const defaults = {};

class Logo {
  constructor(player, options) {
    this.player = player;
    this.options = videojs.mergeOptions(defaults, options);
    this.createElement();
    this.saveInitialProperties();
  }

  createElement() {
    let logoElement = document.createElement("div");
    logoElement.className = "vjs-logo-img";
    logoElement.style.backgroundImage = `url(${this.options.url})`;
    this.player.el().append(logoElement);
    this.el = logoElement;
  }

  saveInitialProperties() {
    let containerWidth = this.player.el().offsetWidth;
    let containerHeight = this.player.el().offsetHeight;
    let style = window.getComputedStyle(this.el);
    // Calculate initial top percents
    let topPercent = Math.round((parseFloat(style.top) / containerHeight) * 100);
    let rightPercent = Math.round((parseFloat(style.right) / containerWidth) * 100);
    let widthPercent = Math.round((parseFloat(style.width) / containerWidth) * 100);
    let heightPercent = Math.round((parseFloat(style.height) / containerHeight) * 100);
    // Save initial top percents
    this.el.setAttribute('init-top-percent', topPercent);
    this.el.setAttribute('init-right-percent', rightPercent);
    this.el.setAttribute('init-top-width', widthPercent);
    this.el.setAttribute('init-right-height', heightPercent);
  }

  moveLogo() {
    let dimensions = this.getRealDimensions();
    if (!dimensions) {
      // Set event listener for next play event
      this.player.one('play', () => this.moveLogo());
      return;
    }
    let logoTopPercent = this.el.getAttribute('init-top-percent') * 1 / 100;
    let logoRightPercent = this.el.getAttribute('init-right-percent') * 1 / 100;
    this.el.style.top = dimensions.blackBar.height + dimensions.video.height * logoTopPercent + 'px';
    this.el.style.right = dimensions.blackBar.width + dimensions.video.width * logoRightPercent + 'px';
    this.changeLogoSize(dimensions.video);
  }

  getRealDimensions() {
    let videoWidth = this.player.videoWidth();
    let videoHeight = this.player.videoHeight();
    if (!videoWidth || !videoHeight) {
      return;
    }
    let elementWidth = this.player.el().offsetWidth;
    let elementHeight = this.player.el().offsetHeight;
    let videoAspectRation = videoWidth / videoHeight;
    let elementAspectRatio = elementWidth / elementHeight;

    let tensileCoeff = 1;
    let blackBarWidth = 0;
    let blackBarHeight = 0;

    // If video aspect ration more than element's
    // then black bars will appear from top and bottom of the video
    if (videoAspectRation > elementAspectRatio) {
      // The height of the black bar lines
      let blackBarsHeight = videoWidth * elementHeight / elementWidth - videoHeight;
      // To get TRUE value of black bar height and video sizes we need to calculate
      // tensile coefficient: ratio of container height to video height with black bar height
      tensileCoeff = elementHeight / (videoHeight + blackBarsHeight);
      blackBarHeight = blackBarsHeight * tensileCoeff / 2;
    } else if (videoAspectRation < elementAspectRatio) {
      // The width of the black bar lines
      let blackBarsWidth = videoHeight * elementWidth / elementHeight - videoWidth;
      // To get TRUE value of black bar height and video sizes we need to calculate
      // tensile coefficient: ratio of container width to video width with black bars width
      tensileCoeff = elementWidth / (videoWidth + blackBarsWidth);
      blackBarWidth = blackBarsWidth * tensileCoeff / 2;
    } else if (videoAspectRation == elementAspectRatio) {
      tensileCoeff = elementWidth / videoWidth;
    }

    return { 
      video: {
        width: videoWidth * tensileCoeff,
        height: videoHeight * tensileCoeff,
      },
      element: {
        width: elementWidth,
        height: elementHeight
      },
      blackBar: {
        width: blackBarWidth,
        height: blackBarHeight
      }
    };
  }

  changeLogoSize(videoDimensions) {
    let widthPercent = this.el.getAttribute('init-top-width') * 1;
    let heightPercent = this.el.getAttribute('init-right-height') * 1;
    let logoWidth = videoDimensions.width * widthPercent / 100;
    let logoHeight = videoDimensions.width * heightPercent / 100;
    this.el.style.width = logoWidth + 'px';
    this.el.style.height = logoHeight + 'px';
  }
}

export default Logo;
